import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useSession } from "./useSession";
import { useAcceptPendingInvitation } from "./useAcceptPendingInvitation";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();
  const location = useLocation();
  // Tourne sur n'importe quelle session établie (magic link, login password,
  // reload de page). Idempotent : ne fait rien s'il n'y a pas d'invitation
  // pending pour l'email de l'user.
  useAcceptPendingInvitation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-subtle-foreground">Chargement…</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
